import React, {useEffect, useState} from 'react';
import {Modal} from 'react-bootstrap';
import {ButtonWithLoading} from '../utils/ButtonWithLoading';
import {SelectInput} from '../utils/SelectInput';
import {useDispatch, useSelector} from 'react-redux';
import {responseSelector} from '../utils/utils';
import {alertTypes} from '../ui/alert';
import {estudioMercadoEditDuck, estudioMercadoEditThunk} from './duck';
const {TextInput, knownRegexes} = require('../utils/TextInput');

const tipoOptions = [
  {label: 'General', value: 'general'},
  {label: 'Específico', value: 'especifico'},
];

function ModalEstudioMercadoEdit({
  token,
  isModalShown,
  hideModal,
  setTopAlert,
  setSelectedEmForEdit,
  selectedEmForEdit,
  recargarEstudiosEspecificos,
  recargarEstudiosGenerales,
}) {
  const dispatch = useDispatch();

  const estudioMercadoEdit = useSelector(state => state.estudioMercadoEdit);

  const [tipoOption, setTipoOption] = useState(() =>
    tipoOptions.find(option => option.value === selectedEmForEdit.tipo),
  );
  const [titulo, setTitulo] = useState(() => selectedEmForEdit.titulo);
  useEffect(() => {
    const {httpStatus, error, errorMessage} =
      responseSelector(estudioMercadoEdit);

    if (error) {
      setTopAlert({
        title: 'Error',
        text: errorMessage,
        type: alertTypes.danger,
        closable: false,
      });

      dispatch(estudioMercadoEditDuck.actions.clear());
    }

    if (httpStatus === 200) {
      setTopAlert({
        text: 'Estudio de mercado editado correctamente',
        type: alertTypes.success,
        closable: false,
      });
      recargarEstudiosEspecificos();
      recargarEstudiosGenerales();
      dispatch(estudioMercadoEditDuck.actions.clear());
      setSelectedEmForEdit(null);
    }
  }, [estudioMercadoEdit]);

  function editarEstudioMercado() {
    if (!titulo || !tipoOption?.value) {
      setTopAlert({
        text: 'Por favor complete todos los campos',
        type: alertTypes.success,
        closable: false,
      });
    }

    dispatch(
      estudioMercadoEditThunk({
        userToken: token.raw,
        estudioMercadoIdNumerico: selectedEmForEdit.idNumerico,
        tipo: tipoOption.value,
        titulo: titulo,
      }),
    );
  }

  return (
    <Modal show={isModalShown} style={{opacity: 1}} onHide={hideModal}>
      <Modal.Header>
        <Modal.Title>Modificar estudio de mercado</Modal.Title>
      </Modal.Header>
      <Modal.Body>
        <TextInput label="Nombre" initialValue={titulo} setValue={setTitulo} />
        <SelectInput
          label="Tipo"
          value={tipoOption}
          options={tipoOptions}
          setValue={setTipoOption}
          required
        />
      </Modal.Body>
      <Modal.Footer>
        <div style={{display: 'flex', justifyContent: 'space-between'}}>
          <ButtonWithLoading
            type="warning"
            text="Volver"
            disabled={estudioMercadoEdit.loading}
            loading={estudioMercadoEdit.loading}
            submit={() => setSelectedEmForEdit(null)}
          />

          <ButtonWithLoading
            type="primary"
            text="Guardar"
            disabled={estudioMercadoEdit.loading}
            loading={estudioMercadoEdit.loading}
            submit={editarEstudioMercado}
          />
        </div>
      </Modal.Footer>
    </Modal>
  );
}

export {ModalEstudioMercadoEdit};
